export default __webpack_public_path__ + "static/media/carousel8.7fe51ea7.jpg";